import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'studio.DncOA1',
    defaultMessage: 'Variable',
  },
  nameLabel: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  nameHelp: {
    id: 'studio.uKgreU',
    defaultMessage: 'The name by which the variable will be accessible',
  },
  valueLabel: {
    id: 'studio.GufXy5',
    defaultMessage: 'Value',
  },
  valueHelp: {
    id: 'studio.pCY3jo',
    defaultMessage: 'The value of the variable',
  },
  close: {
    id: 'studio.rbrahO',
    defaultMessage: 'Close',
  },
  save: {
    id: 'studio.lwffFf',
    defaultMessage: 'Save variable',
  },
  deleteWarningTitle: {
    id: 'studio.h+tTHx',
    defaultMessage: 'Deleting variable',
  },
  deleteWarning: {
    id: 'studio.8yAEFD',
    defaultMessage:
      'Are you sure you want to delete this variable? This action cannot be reverted.',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'studio.GqOPgR',
    defaultMessage: 'Delete variable',
  },
  deleteSuccess: {
    id: 'studio.N3aA7X',
    defaultMessage: 'Successfully deleted variable {name}',
  },
  deleteButton: {
    id: 'studio.GqOPgR',
    defaultMessage: 'Delete variable',
  },
});
